import { WebAuth } from 'auth0-js';

export default new WebAuth({
  domain: window._env_.AUTH0_DOMAIN,
  clientID: window._env_.AUTH0_CLIENT_ID,
  redirectUri: `${window._env_.API_DOMAIN}/auth0/callback`,
  audience: window._env_.AUTH0_AUDIENCE,
  scope: 'openid email profile offline',
  responseType: 'code',
});
